export default {"src":"/_next/static/media/amplo.1d4858fc.svg","height":32,"width":158,"blurWidth":0,"blurHeight":0};